module.exports = __webpack_public_path__ + "static/img/xgy.312b1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xgy.png
// module id = kM+C
// module chunks = 0